import { memo } from "react";
import { bool, number, func, string, oneOf } from "prop-types";
import { BreakdownTableDepths } from "@repo/utils";
import { Badge, capitalize, Grid, IconButton } from "@material-ui/core";
import { ModuleArrow } from "@assets";
import { ExpandMore } from "@material-ui/icons";
import useCellStyle from "../../../../../../styles/CommonTableCellStyles.style";
import useStyle from "./ExpandContainer.style";
import classnames from "classnames";

export const ExpandContainer = memo(({
  expandable,
  expanded,
  onExpand,
  noArrow,
  isHeader,
  presetClassName,
  childrenAmount,
  showBadge,
  tableDepth = BreakdownTableDepths.SECTION,
  size="large",
}) => {
  const classes = useStyle();
  const cellClasses = useCellStyle();
  
  return (
    <Grid
      item container
      alignItems="center"
      justifyContent="flex-end"
      wrap="nowrap"
      className={classnames(
        "mr-1",
        classes.root,
        `d${tableDepth}`,
        isHeader && "ml",
        isHeader && classes.header,
        !isHeader && cellClasses[`sizeInner${capitalize(size)}`],
      )}
    >
      <Badge
        color="primary"
        badgeContent={childrenAmount}
        invisible={!childrenAmount || !showBadge}
        overlap="circular"
        max={9}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        className={presetClassName}
        classes={{
          badge: classnames("counter", classes.badge)
        }}
      >
        {
          expandable
            ? <IconButton
              onClick={onExpand}
              className="noDrag expand"
              tabIndex={-1}
            >
              {
                <ExpandMore
                  className={classnames("transition", expanded ? "rotate-180" : "rotate-0")}
                />
              }
            </IconButton>
            : (
              (!noArrow && !isHeader) &&
              <Grid
                item
                container
                justifyContent="center"
                alignItems="center"
                className={ classes.arrow }
              >
                <ModuleArrow />
              </Grid>
            )
        }
      </Badge>
    </Grid>
  );
});

ExpandContainer.propTypes = {
  expandable: bool,
  expanded: bool,
  noArrow: bool,
  onExpand: func,
  tableDepth: number,
  size: oneOf(["xSmall", "small", "medium", "large", "xLarge", "2XLarge"]),
  isHeader: bool,
  presetClassName: string,
  childrenAmount: number,
  showBadge: bool,
};
